import { Patient } from 'fhir/r4';

export interface RelatedPatientStateInterface {
  list: Patient[]
}

function state(): RelatedPatientStateInterface {
  return {
    list: []
  }
}

export default state